module.exports = __webpack_public_path__ + "img/notification.ef266a85.svg";